import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-parametros-categoria',
  templateUrl: './categoria-parametros.component.html',
  styleUrls: ['./categoria-parametros.component.css']
})
export class CategoriaParametrosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
